import React, { useState } from "react";
import { Check, ChevronDown, ChevronUp, Sparkles } from "lucide-react";
import { STAPLE_GROUPS, USUAL_SUSPECTS } from "../lib/staples";

const norm = (s) => s.trim().toLowerCase();

export default function StaplesPicker({ value = [], onChange, testPrefix = "staples" }) {
  const [open, setOpen] = useState(() => new Set(["pantry"]));
  const have = new Set(value.map(norm));
  const toggle = (item) => (have.has(norm(item)) ? onChange(value.filter((v) => norm(v) !== norm(item))) : onChange([...value, item]));
  const addUsual = () => onChange([...value, ...USUAL_SUSPECTS.filter((u) => !have.has(norm(u)))]);
  const usualLeft = USUAL_SUSPECTS.filter((u) => !have.has(norm(u))).length;
  const flip = (k) => setOpen((p) => { const n = new Set(p); n.has(k) ? n.delete(k) : n.add(k); return n; });

  return (
    <div className="mt-3" data-testid={`${testPrefix}-picker`}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold text-sorted-slate">Tap what's already in your kitchen</p>
        {usualLeft > 0 && (
          <button type="button" onClick={addUsual} data-testid={`${testPrefix}-usual`} className="text-[11px] font-bold text-sorted-rose flex items-center gap-1"><Sparkles size={12} strokeWidth={2.5} /> Add the usual suspects ({usualLeft})</button>
        )}
      </div>
      <div className="mt-2 space-y-2">
        {STAPLE_GROUPS.map((g) => {
          const count = g.items.filter((i) => have.has(norm(i))).length;
          const isOpen = open.has(g.key);
          return (
            <div key={g.key} className="bg-white/80 rounded-2xl border-2 border-[#FDECEF]">
              <button type="button" onClick={() => flip(g.key)} data-testid={`${testPrefix}-group-${g.key}`} className="w-full flex items-center justify-between px-3 py-2.5 text-left">
                <span className="text-sm font-bold text-sorted-ink">{g.label} <span className="text-[11px] font-semibold text-sorted-slate">{count}/{g.items.length}</span></span>
                {isOpen ? <ChevronUp size={16} className="text-sorted-slate" /> : <ChevronDown size={16} className="text-sorted-slate" />}
              </button>
              {isOpen && (
                <div className="px-3 pb-3 flex flex-wrap gap-1.5">
                  {g.items.map((item) => {
                    const on = have.has(norm(item));
                    return (
                      <button key={item} type="button" onClick={() => toggle(item)} data-testid={`${testPrefix}-item-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} data-on={on ? "1" : "0"}
                        className={`px-3 py-1.5 rounded-full text-xs font-bold border-2 flex items-center gap-1 transition-colors ${on ? "bg-sorted-sage border-sorted-sage text-sorted-ink" : "bg-white border-[#FDECEF] text-sorted-slate"}`}>
                        {on && <Check size={12} strokeWidth={3} />}{item}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
